import styled from 'styled-components';
import {LineChart, BarChart} from '@epic-visualizations/charts';
import {getDirectionStyles} from '../../../../../../utils/ThemeUtils';

export const StyledLineChart = styled(LineChart)`
    direction: ltr;
    padding-top: 20px;

    .recharts-surface {
        overflow: visible;

        & [class*='recharts-cartesian-grid'] {
            & [class*='recharts-cartesian-grid'] {
                & line {
                    // Contrast 1
                    stroke: rgba(255, 255, 255, 0.08);
                }
            }
        }
    }

    & [class*='recharts-tooltip-wrapper'] {
        direction: ${p => p.theme.muiTheme.direction};

        & > div {
            background-color: ${p => p.theme.muiTheme.palette.background.default};
        }
    }
`;

export const StyledBarChart = styled(BarChart)`
    direction: ltr;
    margin-top: 20px;

    .recharts-surface {
        overflow: visible;

        & [class*='recharts-cartesian-grid'] {
            & [class*='recharts-cartesian-grid'] {
                & line {
                    // Contrast 1
                    stroke: rgba(255, 255, 255, 0.08);
                }
            }
        }
    }

    & [class*='recharts-tooltip-wrapper'] {
        direction: ${p => p.theme.muiTheme.direction};

        & > div {
            background-color: ${p => p.theme.muiTheme.palette.background.default};
        }
    }

    ${p => p.theme.muiTheme.breakpoints.up('fmd')} {
        & .recharts-cartesian-axis-ticks {
            transform: translateY(-6px);
        }
    }
`;

export const ChartContainer = styled.div`
    padding: ${p => p.theme.muiTheme.spacing(0, 1)};

    ${p => p.theme.muiTheme.breakpoints.up('fsm')} {
        padding: 0;
    }
`;

export const PerformanceChartContainer = styled.div`
    margin: ${p =>
        getDirectionStyles(p.theme.muiTheme.direction)(
            p.theme.muiTheme.spacing(0, 0, 2, -4),
            p.theme.muiTheme.spacing(0, -4, 2, 0)
        )};

    ${p => p.theme.muiTheme.breakpoints.up('md')} {
        margin: 0;
    }
`;

export const TooltipWrapper = styled.div`
    display: flex;
    flex-direction: column;

    & > span:last-of-type {
        margin-left: 18px;
    }
`;
